import React, { useEffect } from 'react';
import Image from 'next/image';
import { WebBodyText18, WebHeading28 } from '@fintronners/react-ui/src/GlobalStyling/webTypography';
import { useTranslation } from 'react-i18next';
import { SuccessCircleIcon } from '@/assets/icons';
import { Button } from '@/components/common/Button';
import { SheetContent, SheetFooter } from '@/components/common/Sheet';
import { useSidePanel } from '@/context/SidePanelContext';

export const RiskProfileSidePanelSuccess = () => {
  const { t } = useTranslation();
  const { closeSidePanel, setShowBackLink } = useSidePanel();

  useEffect(() => {
    setShowBackLink(false);
  }, []);

  return (
    <SheetContent>
      <div className="flex flex-col items-center gap-7 text-center mt-20">
        <Image alt="Success icon" width={50} height={50} src={SuccessCircleIcon.src} />
        <WebHeading28.Bold className="text-darkestBlue">
          {t('common.congratulations')}
        </WebHeading28.Bold>
        <WebBodyText18.Regular className="text-grey72">
          {t('settings.security.riskProfile.success.message')}
        </WebBodyText18.Regular>
      </div>

      <SheetFooter className="my-5 text-center">
        <div className="w-full flex flex-col gap-2">
          <Button onClick={closeSidePanel}>{t('common.done')}</Button>
        </div>
      </SheetFooter>
    </SheetContent>
  );
};
